<template>
    <div>
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
                <el-form-item >
                    <el-input  v-model="argument.keyword" placeholder="请输入关键字"></el-input>
                </el-form-item>
                <el-select v-model="argument.status" placeholder="请选择支付状态">
                    <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="argument.pay_type" placeholder="请选择支付状态" style="margin: 0px 10px">
                    <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-date-picker
                        v-model="time"
                        type="daterange"
                        @change="chosedatetime"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-button  type="primary" @click="searchBtn">搜索</el-button>
            <el-button  @click="emptyBtn" >清空</el-button>
        </el-form>
        <div style="color: #409EFF;font-size: 18px;font-weight: bold">订单总金额：{{total_money}}</div>
        <avue-crud :data="data" :option="option" :page.sync="page"  @current-change="changePage">
            <template slot="menuBtn" slot-scope="scope" >
                <el-dropdown-item class="pull-down" @click.native="viewCode(scope.row)" v-if="scope.row.status==1">获取订单二维码</el-dropdown-item>
            </template>
            <template slot="order_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.order_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.order_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="com_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.com_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.com_name }}</p>
                </el-tooltip>
            </template>
            <template slot="pay_com_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.pay_com_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.pay_com_name }}</p>
                </el-tooltip>
            </template>
            <template slot="signer_txt" slot-scope="scope" >
                <el-tooltip :content="scope.row.signer_txt" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.signer_txt }}</p>
                </el-tooltip>
            </template>
            <template slot="update_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.update_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.update_time }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <!--        获取订单二维码-->
        <el-dialog
                title="获取订单二维码"
                :visible.sync="orderCode"
                :close-on-click-modal="false"
                width="30%">
            <img :src="'data:image/png;base64,' + base64Image" alt="">
            <p>请用手机浏览器扫码支付</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="orderCode = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { get_QR_code, orderList } from '../../../api/order';

    export default {
        name: 'Ipaid',
        data() {
            return {
                orderCode:false,
                total_money:'', //订单总金额
                base64Image:'',
                argument:{
                    keyword:'',
                    status:'',
                    pay_type:'',
                    begin_time:'',
                    end_time:'',
                },
                time:[],
                //支付状态
                statusList:[
                    {
                        value: '1',
                        label: '待支付'
                    },
                    {
                        value: '2',
                        label: '已支付'
                    },
                    {
                        value: '3',
                        label: '取消支付'
                    },
                ],
                //支付类型
                typeList:[
                    {
                        value: '1',
                        label: '微信'
                    },
                    {
                        value: '2',
                        label: '支付宝'
                    },
                ],
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [],
                option:{
                    stripe:true,
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:150,  //操作栏宽度设置
                    searchLabelWidth:120,  //搜索栏标题宽度
                    column:[
                        {
                            label:'订单ID',
                            prop:'id'
                        }, {
                            label:'订单号',
                            prop:'order_sn'
                        }, {
                            label:'合同名称',
                            prop:'doc_title'
                        }, {
                            label:'发起人个人名称',
                            prop:'user_name'
                        }, {
                            label:'发起人企业名称',
                            prop:'com_name'
                        }, {
                            label:'支付人姓名',
                            prop:'pay_name'
                        }, {
                            label:'支付人手机号',
                            prop:'pay_mobile'
                        }, {
                            label:'支付人企业',
                            prop:'pay_com_name'
                        }, {
                            label:'支付状态',
                            prop:'status_txt'
                        }, {
                            label:'支付类型',
                            prop:'pay_type_txt'
                        }, {
                            label:'签署方',
                            prop:'signer_txt'
                        }, {
                            label:'支付金额(元)',
                            prop:'money'
                        }, {
                            label:'下单或支付时间',
                            prop:'update_time',
                        },
                    ]
                },
            };
        },
        methods:{
            //选择时间
            chosedatetime(obj){
                if(obj){
                    this.argument.begin_time = obj[0]
                    this.argument.end_time = obj[1]
                }else{
                    this.argument.begin_time = ''
                    this.argument.end_time = ''
                }
            },
            //分页
            changePage(num){
                if (this.argument.keyword==''&&this.argument.status==''&&this.argument.pay_type==''&&this.argument.begin_time==''&&this.argument.end_time==''){
                    orderList(10,num,2).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('Ipaid',num)
                            this.total_money=res.data.total_money
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }else {
                    //搜索后分页
                    orderList(10,num,2,this.argument.keyword,this.argument.status,this.argument.pay_type,this.argument.begin_time,this.argument.end_time).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('IpaidSearch', num)
                            this.total_money=res.data.total_money
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }

            },
            //搜索
            searchBtn(){
                orderList(10,1,2,this.argument.keyword,this.argument.status,this.argument.pay_type,this.argument.begin_time,this.argument.end_time).then(res=>{
                    if (res.code==200){
                        sessionStorage.setItem('IpaidSearch', 1)
                        sessionStorage.setItem('IpaidParams', JSON.stringify(this.argument) )
                        this.total_money=res.data.total_money
                        this.data=res.data.list
                        this.page.total=res.data.count
                    }
                })
            },
            //重置
            emptyBtn(){
                this.time=[]
                this.argument.keyword=''
                this.argument.status=''
                this.argument.pay_type=''
                this.argument.begin_time=''
                this.argument.end_time=''
                this.getList()
                sessionStorage.removeItem('Ipaid')
                sessionStorage.removeItem('IpaidSearch')
                sessionStorage.removeItem('IpaidParams')
            },
            getList(){
                orderList(10,1,2).then(res=>{
                    if (res.code==200){
                        this.total_money=res.data.total_money
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
            },
            //获取支付二维码
            viewCode(row){
                get_QR_code(row.id).then(res=>{
                    if (res.code==200){
                        this.orderCode=true
                        this.base64Image=res.data.base64Imagedata
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            if (sessionStorage.getItem('IpaidSearch')){
                let waitMeParams=JSON.parse(sessionStorage.getItem('IpaidParams'))
                //时间转换进行回显
                let  arr=[]
                arr.push(waitMeParams.begin_time)
                arr.push(waitMeParams.end_time)
                this.time=arr
                this.argument=waitMeParams
                orderList(10,sessionStorage.getItem('IpaidSearch'),2,waitMeParams.keyword,waitMeParams.status,waitMeParams.pay_type,waitMeParams.begin_time,waitMeParams.end_time).then(res=>{
                    if (res.code==200){
                        this.total_money=res.data.total_money
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('IpaidSearch')
                    }
                })
            }else {
                if (sessionStorage.getItem('Ipaid')===null){
                    this.getList()
                }else {
                    orderList(10,sessionStorage.getItem('Ipaid'),2).then(res=>{
                        if (res.code==200){
                            this.total_money=res.data.total_money
                            this.data=res.data.list
                            this.page.total=res.data.count
                            this.page.currentPage=sessionStorage.getItem('Ipaid')
                        }
                    })
                }
            }
        }
    };
</script>

<style scoped>
    .pull-down{
        padding: 5px 30px !important;
    }
    /deep/.el-dialog__body{
        text-align: center;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
    ::v-deep .avue-crud__menu{
        min-height:0px !important;
        height: 0px !important;
    }
    ::v-deep .el-form-item{
        margin-bottom: 10px
    }
</style>
